import makeStyles from '@material-ui/core/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import Button from './Button';
import { color, fontSize } from '../common/themes';
import useResponsiveScale from './hooks/useResponsiveScale';

const useStyles = makeStyles(
	() => ({
		customerFormTitle: {
			fontSize: ({ fontScale }: any) => fontSize.md * (fontScale || 1),
			color: color.$13,
			marginBottom: 24,
		},
		customerForm: {
			backgroundColor: color.$7,
			wordWrap: 'break-word',
			padding: '16px',
			width: 204,
			boxShadow: '0 8px 36px 0 rgba(0, 0, 0, 0.06)',
			borderRadius: 12,
		},
		customerFormRow: {
			marginBottom: 12,
		},
		customerFormButton: {
			width: '100%',
		},
	}),
	{
		name: 'CustomerFormDone',
	}
);

const CustomerFormDone = ({ data, submitCustomerFormMessage }: any) => {
	const { fontScale } = useResponsiveScale();
	const classes = useStyles({ fontScale });
	const { t } = useTranslation();

	const submitForm = () => {
		const newData = JSON.parse(JSON.stringify(data));
		newData.contentType = 'application/x-customer-form';
		newData.data.displayName = '';
		newData.data.email = '';
		newData.data.phone = '';

		submitCustomerFormMessage(newData);
	};

	return (
		<div className={classes.customerForm}>
			<div className={classes.customerFormTitle}>
				{t('formDone', { displayName: data.data.displayName, email: data.data.email || data.data.phone })}
			</div>
			<Button
				topic="primaryGreen"
				onClick={() => {
					submitForm();
				}}
				className={classes.customerFormButton}
			>
				{t('reEdit')}
			</Button>
		</div>
	);
};

export default CustomerFormDone;
